import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const buyers = [{
  name: 'Valentina',
  img: 'https://i.pravatar.cc/80?img=1'
}, {
  name: 'Camila',
  img: 'https://i.pravatar.cc/80?img=5'
}, {
  name: 'Lucía',
  img: 'https://i.pravatar.cc/80?img=9'
}, {
  name: 'Martina',
  img: 'https://i.pravatar.cc/80?img=16'
}, {
  name: 'Sofía',
  img: 'https://i.pravatar.cc/80?img=20'
}, {
  name: 'Paula',
  img: 'https://i.pravatar.cc/80?img=23'
}, {
  name: 'Julieta',
  img: 'https://i.pravatar.cc/80?img=25'
}, {
  name: 'Rocío',
  img: 'https://i.pravatar.cc/80?img=32'
}, {
  name: 'Milagros',
  img: 'https://i.pravatar.cc/80?img=44'
}, {
  name: 'Daniela',
  img: 'https://i.pravatar.cc/80?img=47'
}, {
  name: 'Andrea',
  img: 'https://i.pravatar.cc/80?img=48'
}, {
  name: 'Natalia',
  img: 'https://i.pravatar.cc/80?img=49'
}];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentData, setCurrentData] = useState({
    name: '',
    city: '',
    minutes: 0,
    img: ''
  });
  useEffect(() => {
    const triggerPopup = () => {
      const buyer = buyers[Math.floor(Math.random() * buyers.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomMinutes = Math.floor(Math.random() * 14) + 2;
      setCurrentData({
        name: buyer.name,
        city: randomCity,
        minutes: randomMinutes,
        img: buyer.img
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimeout = setTimeout(triggerPopup, 3000);
    const interval = setInterval(() => {
      if (!isVisible) {
        triggerPopup();
      }
    }, Math.floor(Math.random() * 3000) + 8000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-115">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-gradient-to-r from-orange-50 to-amber-50 rounded-xl shadow-[0_8px_30px_rgba(234,88,12,0.18)] border border-orange-200 p-3 pr-6 max-w-sm flex items-center gap-3 cursor-pointer" onClick={() => window.location.href = 'https://payments.vantapro.shop/cart/44978652708966:1'} data-id="element-116">
          <img src={currentData.img} alt={currentData.name} className="w-11 h-11 rounded-full object-cover border-2 border-orange-300 flex-shrink-0" data-id="element-117" />
          <div className="flex-1 min-w-0" data-id="element-118">
            <p className="text-sm text-gray-800 font-medium leading-tight" data-id="element-119">
              🔥 <span className="font-bold" data-id="element-120">{currentData.name}</span> de{' '}
              {currentData.city} compró el Kit Completo
            </p>
            <p className="text-xs text-orange-600 mt-0.5 font-medium flex items-center gap-1" data-id="element-121">
              <CheckCircle2 className="w-3.5 h-3.5 text-green-500" data-id="element-122" />
              hace {currentData.minutes} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}